import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent, Button, DialogActions, Box,
} from "@mui/material";

import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from "material-react-table";

import { useGetVersOreByDipAndData } from "./Services";

interface Props {
  data: {
    coddip: string;
    day: string;
    mese: number;
    anno: number;
    nomedip: string;
  } | null;
}

const MonitorTimeReportTable: React.FC<Props> = ({
  data,
}) => {
  // ----------------------
  // Build DATAREG
  // ----------------------
  // const datareg = data
  //   ? `${data.anno}-${String(data.mese).padStart(2, "0")}-${String(data.day).padStart(2, "0")}`
  //   : "";

  const datareg = data
    ? `${String(data.day).padStart(2, "0")}/${String(data.mese).padStart(2, "0")}/${data.anno}`
    : "";


  // ----------------------
  // API CALL
  // ----------------------
  const {
    data: { results = [] } = {},
    isLoading,
  } = useGetVersOreByDipAndData(data?.coddip ?? "", datareg);

  // ----------------------
  // Columns
  // ----------------------
  const columns = useMemo<MRT_ColumnDef<any>[]>(() => [
  { accessorKey: 'nrrel', header: 'NrRel', size: 20 },
  { accessorKey: 'coddip', header: 'Dip', size: 10 },

  {
    accessorKey: 'datareg',
    header: 'Data',
    size: 40,
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();
      if (!value) return '';
      return new Date(value).toLocaleDateString('it-IT');
    },
  },

  {
    accessorKey: 'desprog',
    header: 'Prog',
    size: 80,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 75 ? `${value.substring(0, 15)}...` : value}
        </span>
      );
    },
  },

  {
    accessorKey: 'desatt',
    header: 'Attività',
    size: 30,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 30 ? `${value.substring(0, 15)}...` : value}
        </span>
      );
    },
  },

  {
    accessorKey: 'note',
    header: 'Note',
    size: 200,
    Cell: ({ cell }) => {
      const value = (cell.getValue() ?? '') as string;
      return (
        <span title={value}>
          {value.length > 200 ? `${value.substring(0, 25)}...` : value}
        </span>
      );
    },
  },

  { accessorKey: 'oremineff', header: 'OreEff', size: 60 },
  { accessorKey: 'luogo', header: 'Luogo', size: 80 },

], []);

  // ----------------------
  // Table
  // ----------------------
  const table = useMaterialReactTable({
    columns,
    data: results,

    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableColumnActions: false,
    enableSorting: false,
    enablePagination: false,

    state: {
      isLoading,
    },

    muiTableProps: {
      sx: {
        '& .MuiTableCell-root': {
          padding: '2px 6px',
          fontSize: '0.75rem',
        },
      },
    },
    muiTableBodyRowProps: {
      sx: { height: '28px' },
    },
    muiTableHeadRowProps: {
      sx: { height: '30px' },
    },
  });

  // ----------------------
  // UI
  // ----------------------
  return (

        <MaterialReactTable table={table} />

  );
};

export default MonitorTimeReportTable;